module.exports = {
  encode: require( './encode' ),
  decode: require( './decode' ),
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/google-polyline/lib/polyline.js
// module id = 547
// module chunks = 0